export default "<p>\n  <!-- profile-user works! -->\n</p>\n"